/**
 * System variables available during a call
 * These are values that can be automatically extracted from the system context
 */
export const twillioSystemVariable = [
	// { value: 'call_sid', label: 'Call SID' },
	{ value: 'caller_phone_number', label: 'Caller Phone Number' },
	{ value: 'receptionist_number', label: 'Receptionist Number' },
	{ value: 'call_date', label: 'Call Date' },
	{ value: 'call_time', label: 'Call Time' },
	{ value: 'caller_country', label: 'Caller Country' },
	{ value: 'caller_state', label: 'Caller State' },
];
